import { memo } from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';

import { Button } from '../button/Button';
import { useStyles } from './ConfirmationDialog.styles';
import { ConfirmationDialogProps } from './ConfirmationDialog.types';

export const ConfirmationDialog = memo(
  ({
    message,
    confirmButtonText,
    confirmationButtonType = 'twoTone',
    confirmationButtonColor,
    hideConfirmButton,
    cancelButtonText,
    cancelButtonType = 'text',
    cancelButtonColor = 'primary',
    hideCancelButton,
    maxWidth = 456,
    isLoading = false,
    onConfirm,
    onClose,
  }: ConfirmationDialogProps) => {
    const styles = useStyles({ maxWidth });

    return (
      <Grid container className={styles.container}>
        <div className={styles.wrapper}>
          <div>
            <Typography variant="body1" component="div" className={styles.message}>
              {message ?? 'Are you sure you want to do this?'}
            </Typography>
          </div>

          <Grid className={styles.buttonsContainer} container justifyContent="flex-end" spacing={1}>
            {!hideCancelButton && (
              <Grid item>
                <Button buttonType={cancelButtonType} color={cancelButtonColor} onClick={onClose}>
                  {cancelButtonText ?? 'Cancel'}
                </Button>
              </Grid>
            )}

            {!hideConfirmButton && (
              <Grid item>
                <Button
                  buttonType={confirmationButtonType}
                  color={confirmationButtonColor}
                  isLoading={isLoading}
                  className={clsx(confirmationButtonType !== 'text' && styles.confirmButton)}
                  onClick={() => onConfirm()}
                >
                  {confirmButtonText ?? 'Confirm'}
                </Button>
              </Grid>
            )}
          </Grid>
        </div>
      </Grid>
    );
  },
);
